import { Component } from '@angular/core';
import { ToastController, NavParams, ViewController,ModalController } from 'ionic-angular';

import { Params } from '../params';
import * as firebase from 'firebase/app';


@Component({
  selector: 'page-addIngredient',
  template: `
<ion-header>
  <ion-toolbar color="primary">
    <ion-title>
      Ingredientes
    </ion-title>
    <ion-buttons start>
      <button ion-button (click)="save()">
        <span ion-text >Guardar</span>
      </button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
    <ion-item><b>Todos los valores a ingresar deben ser en crudo</b></ion-item>
   <ion-grid>
            <ion-row>
                <ion-col col-3>Ingrediente</ion-col>
                <ion-col col-1>Precio</ion-col>
                <ion-col col-2>Cantidad Hombre</ion-col>
                <ion-col col-1>Subtotal</ion-col>
                <ion-col col-2>Cantidad Mujer</ion-col>
                <ion-col col-1>Subtotal</ion-col>
                <ion-col col-1></ion-col>
            </ion-row>
            <ion-row *ngFor="let p of recipe.ingredients">
                <ion-col col-3>
                  <button *ngIf="!p.selected" ion-button padding (click)="selIng(p)">
                    Seleccione
                  </button>
                  {{p.name}}
                </ion-col>
                <ion-col col-1 *ngIf="p.selected">{{money(p.prize)}}</ion-col>
                <ion-col col-2 *ngIf="p.selected"><ion-input style="width: 80%;float:left;" type="number" [(ngModel)]="p.qtym" placeholder="Cantidad Hombre"></ion-input>{{p.measure}}</ion-col>
                <ion-col col-1 *ngIf="p.selected">{{money(p.qtym*p.prize)}}</ion-col>
                <ion-col col-2 *ngIf="p.selected"><ion-input style="width: 80%;float:left;" type="number" [(ngModel)]="p.qtyw" placeholder="Cantidad Mujer"></ion-input>{{p.measure}}</ion-col>
                <ion-col col-1 *ngIf="p.selected">{{money(p.qtyw*p.prize)}}</ion-col>
                <ion-col col-1 *ngIf="p.selected">
                    <button ion-button icon-only color="secondary" (click)="remProd(p)" small>
                        <ion-icon name="trash" ></ion-icon>
                    </button>
                </ion-col>
            </ion-row>
        </ion-grid>
</ion-content>
<ion-footer padding style="background-color:white">
    Agregar Ingrediente <button ion-button icon-only color="primary" (click)="addProd()" small>
                        <ion-icon name="add" ></ion-icon>
                    </button>
</ion-footer>
`})
export class addIngredient {
  recipe;
  money;
  ingredients;
  emptyIngredient = {};
  constructor(
    public params: NavParams,
    public viewCtrl: ViewController,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController
  ) {
    this.emptyIngredient = {
      qtym : 1,
      qtyw : 1,
      prize : 0,
      name : "",
      selected : false,
      key : "",
      measure:"",
      netcost : 0
    };
    this.recipe = this.params.get("item");
    this.money = Params.money;
    firebase.database().ref('/ingredients').orderByChild("active").equalTo(true).once('value').then((snapshot)=>{
      this.ingredients = snapshot.val();

      if(typeof this.recipe.ingredients=="undefined"){
        this.recipe.ingredients = [Object.assign({}, this.emptyIngredient)];
      }else{
        for(let i=0;i<this.recipe.ingredients.length;i++){
          this.recipe.ingredients[i].prize = Number(this.ingredients[this.recipe.ingredients[i].key].netcost);
        }
      }
      console.log(this.ingredients,this.recipe.ingredients);
    });
  }

  selIng(m){
    let index = this.recipe.ingredients.indexOf(m);
    let modal = this.modalCtrl.create(FindIngredientPage,{ingredients:this.ingredients});
    modal.onDidDismiss(data => {
      if(typeof data!="undefined" && data!=null){
        console.log("selected!",data);
        this.recipe.ingredients[index].key = data.key;
        this.recipe.ingredients[index].selected = true;
        this.recipe.ingredients[index].name = data.name;
        this.recipe.ingredients[index].measure = data.measure;
        this.recipe.ingredients[index].prize = Number(data.netcost);
      }
    });
    modal.present();
  }

  addProd(){
    this.recipe.ingredients.push(Object.assign({}, this.emptyIngredient))
  }

  save() {
    let key = this.recipe.$key;
    let inds = [];
    for(let i=0;i<this.recipe.ingredients.length;i++){
      if(this.recipe.ingredients[i].key!=""){
        inds.push(this.recipe.ingredients[i]);
      }
    }
    this.recipe.ingredients = inds;
    /* this.recipeRef = this.db.object('recipes/'+key);
    this.recipeRef.set(this.recipe).then(_ => {
      let toast = this.toastCtrl.create({
        message: "Ingredientes actualizados correctamente",
        duration: 3000
      });
      toast.present();
    }); */

    this.viewCtrl.dismiss();
  }

  remProd(prod){
    let ind = this.recipe.ingredients.indexOf(prod);
    if(ind!=-1) this.recipe.ingredients.splice(ind,1);
  }
}

@Component({template: `
<ion-header>
  <ion-toolbar>
    <ion-title>
      {{title}}
    </ion-title>
    <ion-buttons end>
      <button ion-button (click)="dismiss()">
        <span ion-text color="primary">Cancelar</span>
      </button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-searchbar (ionInput)="getItems($event)" placeholder="Buscar por nombre o código"></ion-searchbar>
  <ion-list>
    <ion-item *ngFor="let item of items" (click)="selected(item)">
      {{ itemsRef[item].name }}
    </ion-item>
  </ion-list>
</ion-content>
`})
export class FindIngredientPage {
  items;
  itemsRef;
  constructor(
    public params: NavParams,
    public viewCtrl: ViewController
  ) {
    this.initializeItems();
  }

  initializeItems() {
    this.itemsRef = this.params.get('ingredients');
    this.items = Object.keys(this.params.get('ingredients'));
  }


  selected(item){
    this.viewCtrl.dismiss(this.itemsRef[item])
  }

  getItems(ev: any) {
    this.initializeItems();
    let val = ev.target.value;
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return ((this.itemsRef[item].name.toLowerCase().indexOf(val.toLowerCase()) > -1) || (this.itemsRef[item].key.toLowerCase().indexOf(val.toLowerCase()) > -1));
      })
    }
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/recipes/addIngredient.ts